import { isBrowser } from '../constants';
import { publicApi } from './index';

export const generateAndDeployToken = async (
  file: File,
  addressList: string[],
  fileUuid: string,
  name: string,
  symbol: string,
  description: string,
  tokenImage: File
) => {
  const bodyData = new FormData();
  bodyData.append('inputType', 'csv');
  bodyData.append('fileUuid', fileUuid);
  bodyData.append('name', name);
  bodyData.append('symbol', symbol);
  if (file) {
    bodyData.append('file', file);
  }
  if (addressList) {
    bodyData.append('addressList', JSON.stringify(addressList));
  }
  if (description) {
    bodyData.append('description', description);
  }
  if (tokenImage) {
    bodyData.append('tokenImage', tokenImage);
  }

  return publicApi.post(
    `/audience/airdrop`,
    bodyData,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      : {}
  );
};
